import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  createDynamicManualWithdrawRequest,
  getOneGateway,
  requestWithdrawOtp,
} from "../../../../../redux/user/actions";
import {
  gatewayFormValidatorWithCustomErrors,
  VALIDATORS,
} from "../../../../../utils/gatewayFormValidator";
import { useSelector } from "react-redux";
import { Toaster } from "../../../../../utils/toaster";
import { APP_CONST, BankModeRequiredFields } from "../../../../../config/const";
import HeaderAfterLogin from "../../../../../containers/HeaderAfterLogin";
import { Button, Container, Form } from "react-bootstrap";
import GatewayFields from "../../../../components/gateways/GatewayFields";

import { useNavigate } from "react-router-dom";
import LeftBarSports from "../../../../components/LeftBarSports";
import PreWithdrawForm from "../../../../components/gateways/PreWithdrawForm";
import DisplayValues from "../../../../components/gateways/displayValues";
import BackIcon from "../../../../../assets/svg/BackIcon";
import ListBankDetails from "../listBankDetails";

const AccSelectionModes = {
  Auto: "auto",
  Manual: "manual",
};

const ACC_SELECTION_TABS = [
  { id: 0, name: "Select bank", key: AccSelectionModes.Auto },
  { id: 1, name: "Manual", key: AccSelectionModes.Manual },
];
const DynamicManualWithdrawGtw = ({ activeGtwId = null }) => {
  const { gateway } = useParams();
  const { wallet } = useSelector((state) => state?.auth);
  const gtwId = gateway || activeGtwId;
  const [gtw, setGtw] = useState(null);
  const [errors, setErrors] = useState({});
  const [formData, setFormdata] = useState({});
  const [isRequesting, setIsRequesting] = useState(false);
  const [isOtpSent, setIsOtpSent] = useState(false);

  /**@type {[{id:string | number} | null , React.Dispatch<React.SetStateAction<{id:string | number} | null>>]} */
  const [playerBankDetails, setPlayerBankDetails] = useState(null);
  const [activeAccSelectionMode, setActiveAccSelectionMode] = useState(
    AccSelectionModes.Auto
  );
  const [isBankMode, setIsBankMode] = useState(false);
  const [withdrawOtpConfig, setWithdrawOtpConfig] = useState({
    otpRequired: false,
    otpSent: false,
    isSendingOtp: false,
    otpValue: "",
    otpSubmitted: false,
  });
  const navigate = useNavigate();
  useEffect(() => {
    if (gtwId) {
      getOneGtwFromServer(gtwId);
    }
  }, [gtwId]);

  /**
   *
   * @param {string} gtwId
   */
  const getOneGtwFromServer = async (gtwId) => {
    const response = await getOneGateway(gtwId);
    if (response && response?.data?.data?.data) {
      setGtw(response?.data?.data?.data);
      setWithdrawOtpConfig((p) => ({
        ...p,
        otpRequired:
          response?.data?.data?.data.withdrawSettings?.otpRequired || false,
      }));
      /**@type {boolean} */
      const isBankMode = response?.data?.data?.data?.withdrawFields?.some(
        (s) => s?.accessor === "accountNo"
      );

      setIsBankMode(isBankMode);
    }
  };

  const validateData = (dataToValidate = {}) => {
    let amountValidationArray = [
      {
        validationValue: wallet.cash,
        type: VALIDATORS.Max,
        customMessage: "Insufficient Balance",
      },
    ];

    if (gtw?.withdrawSettings?.min) {
      amountValidationArray.push({
        validationValue: gtw?.withdrawSettings?.min,
        type: VALIDATORS.Min,
        customMessage: `Min allowed amount is ${gtw?.withdrawSettings?.min}`,
      });
    }

    if (gtw?.withdrawSettings?.max) {
      amountValidationArray.push({
        validationValue: gtw?.withdrawSettings?.max,
        type: VALIDATORS.Max,
        customMessage: `Max allowed amount is ${gtw?.withdrawSettings?.max}`,
      });
    }

    let validatorPayload = {
      fields: gtw?.withdrawFields,
      dataToValidate: dataToValidate,
      // Custom validations for gateway form
      cstmValidation: {
        amount: amountValidationArray,
      },
    };

    if (activeAccSelectionMode === AccSelectionModes.Auto && isBankMode) {
      validatorPayload["keysToSkip"] = BankModeRequiredFields;
    }
    const errors = gatewayFormValidatorWithCustomErrors(validatorPayload);

    setErrors(errors);
    return errors;
  };

  // Function to check and add default values to the form data
  const getIfDefaultValue = ({ data }) => {
    let updatedData = { ...data };
    gtw?.withdrawFields?.forEach((f) => {
      if (!Boolean(data[f?.accessor]) && Boolean(f?.value)) {
        updatedData[f?.accessor] = f?.value;
      }
    });
    return updatedData;
  };

  /**
   *
   * @param {{event:React.ChangeEvent<HTMLInputElement>; isFile:boolean;fieldType?:string}} param0
   *
   */
  const handleChange = ({ event, isFile = false, fieldType = null }) => {
    const name = event?.target?.name;
    const value = isFile
      ? event?.target?.files[0]
      : fieldType === "number"
      ? parseInt(event?.target?.value)
      : event?.target?.value;

    const data = { ...formData, [name]: value };
    validateData(data);
    setFormdata(data);
  };

  /**
   *
   * @param {React.FormEvent<HTMLFormElement>} e
   */
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Return if auto bank details tab active and bank not selected or if error
    if (
      activeAccSelectionMode === AccSelectionModes.Auto &&
      (playerBankDetails === null || !playerBankDetails?.id) &&
      isBankMode
    ) {
      Toaster(
        APP_CONST.TOAST_TYPE.ERROR,
        "Please select account from the list to continue"
      );
      return;
    }

    if (
      Object.keys(validateData(formData)).length ||
      gtw?.withdrawUrl.indexOf("dynamic") < 0
    ) {
      return;
    }

    if (gtw?.slug && gtw?.slug !== null) {
      formData["slug"] = gtw?.slug;
    }

    if (playerBankDetails?.id && isBankMode) {
      formData["bankDetailsId"] = playerBankDetails?.id;
    } else {
      delete formData?.bankDetailsId;
    }

    const dataWithDefaultValues = getIfDefaultValue({ data: formData });

    const finalPayload = {
      ...dataWithDefaultValues,
      dynamicFields: dataWithDefaultValues,
    };
    if (
      withdrawOtpConfig.otpRequired &&
      withdrawOtpConfig?.otpSubmitted &&
      withdrawOtpConfig?.otpSent
    ) {
      finalPayload["otp"] = withdrawOtpConfig?.otpValue;
    }

    setIsRequesting(true);
    const response = await createDynamicManualWithdrawRequest({
      payload: finalPayload,
      isMultiPart: gtw?.withdrawFields.some(
        (s) => s?.type === "file" || s?.type === "image"
      ),
    });
    setIsRequesting(false);
    if (response) {
      setIsOtpSent(false);
      Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "Request created");
    }
  };

  const handleGenerateOtp = async () => {
    setWithdrawOtpConfig((p) => ({ ...p, isSendingOtp: true }));
    const otpResponse = await requestWithdrawOtp({ slug: gtw?.slug });
    setWithdrawOtpConfig((p) => ({ ...p, isSendingOtp: false }));
    if (otpResponse) {
      Toaster(
        APP_CONST.TOAST_TYPE.SUCCESS,
        "Withdraw OTP sent on registered mobile number"
      );
      setWithdrawOtpConfig((p) => ({ ...p, otpSent: true }));
    }
  };
  const AccountSelectionTabs = () => {
    return (
      <ul className="acc-selection-tabs">
        {ACC_SELECTION_TABS.map((tab, idx) => {
          return (
            <li
              key={idx}
              className={tab?.key === activeAccSelectionMode ? "active" : ""}
              onClick={() => {
                // Reset values on mode change
                setErrors({});
                setFormdata({});
                setActiveAccSelectionMode(tab.key);
                setPlayerBankDetails(null);
              }}
            >
              {tab.name}
            </li>
          );
        })}
      </ul>
    );
  };
  return (
    <>
      {activeGtwId == null && <HeaderAfterLogin />}

      {activeGtwId === null ? (
        <main className="main">
          <div className="main-page">
            <Container>
              {!withdrawOtpConfig?.otpRequired ||
              (withdrawOtpConfig?.otpRequired &&
                withdrawOtpConfig?.otpSubmitted) ? (
                <>
                  <div className="heading mt-4">
                    <h4>{gtw?.name}</h4>
                    <div className="back-link" onClick={() => navigate(-1)}>
                      Back <BackIcon />
                    </div>
                  </div>

                  <div className="withdrawinnerpage">
                    <DisplayValues
                      displayItems={gtw?.withdrawDisplayFields || []}
                    />
                    {isBankMode && <AccountSelectionTabs />}

                    {isBankMode && (
                      <div
                        className={
                          activeAccSelectionMode === AccSelectionModes.Auto
                            ? "WithDrawSection"
                            : "WithDrawSection d-none"
                        }
                      >
                        <ListBankDetails
                          setPlayerBankId={setPlayerBankDetails}
                          setAutoPopulateBankDetails={() => {}}
                        />
                      </div>
                    )}
                    <Form className="gatewayForm" onSubmit={handleSubmit}>
                      {gtw?.withdrawFields?.map((f, i) => {
                        return (
                          <GatewayFields
                            key={i}
                            field={f}
                            index={i}
                            handleChange={handleChange}
                            formData={formData}
                            errors={errors}
                            hideFieldManually={
                              activeAccSelectionMode ==
                                AccSelectionModes.Auto &&
                              f?.accessor !== "amount" &&
                              BankModeRequiredFields.includes(f?.accessor)
                            }
                          />
                        );
                      })}
                      <span className="focus-border">
                        <i></i>
                      </span>

                      <Button
                        type="submit"
                        disabled={
                          isRequesting ||
                          (withdrawOtpConfig?.otpRequired &&
                            !withdrawOtpConfig?.otpSent)
                        }
                      >
                        {isRequesting ? "Loading..." : "Submit"}
                      </Button>
                      {withdrawOtpConfig?.otpRequired && (
                        <Button
                          onClick={() => {
                            setWithdrawOtpConfig((p) => ({
                              ...p,
                              otpSent: false,
                              otpSubmitted: false,
                            }));

                            setFormdata({});
                          }}
                          className="my-2"
                        >
                          Re Send OTP
                        </Button>
                      )}
                      <Button onClick={() => navigate("/withdrawList")}>
                        View Request
                      </Button>
                    </Form>
                  </div>
                </>
              ) : (
                <>
                  {" "}
                  <div className="heading mt-4">
                    <h4>{gtw?.name}</h4>
                    <div className="back-link" onClick={() => navigate(-1)}>
                      Back <BackIcon />
                    </div>
                  </div>
                  <PreWithdrawForm
                    onGenerateOtp={handleGenerateOtp}
                    withdrawOtpConfig={withdrawOtpConfig}
                    onSubmit={(otp) => {
                      setWithdrawOtpConfig((p) => ({
                        ...p,
                        otpValue: otp,
                        otpSubmitted: true,
                      }));
                    }}
                  />
                </>
              )}
            </Container>
          </div>
        </main>
      ) : (
        <div className="WithdrawList">
          <h4 className="headingSec">{gtw?.name}</h4>
          <DisplayValues displayItems={gtw?.withdrawDisplayFields || []} />
          <Form className="gatewayForm" onSubmit={handleSubmit}>
            {gtw?.withdrawFields?.map((f, i) => {
              return (
                <GatewayFields
                  key={i}
                  field={f}
                  index={i}
                  handleChange={handleChange}
                  formData={formData}
                  errors={errors}
                />
              );
            })}
            <span className="focus-border">
              <i></i>
            </span>

            <Button type="submit" disabled={isRequesting}>
              {isRequesting ? "Loading..." : "Submit"}
            </Button>
          </Form>
        </div>
      )}
    </>
  );
};
export default DynamicManualWithdrawGtw;
